import type React from "react";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useGetPhysicianHandledPatient } from "api/hooks/useGetPhysicianHandledPatient";
import { Spinner } from "shared/atoms/Spinner";

import { PhysicianMedicalReferralItem } from "../../../PatientHeader/PhysicianToDoTable/components/PhysicianMedicalReferralItem";
import { PlanOfCareItem } from "../../../PatientHeader/PhysicianToDoTable/components/PlanOfCareItem";

interface Props {
  patientId: number;
}

export const PhysicianList: React.FC<Props> = ({ patientId }) => {
  const { data, isLoading } = useGetPhysicianHandledPatient(patientId);
  const { t } = useTranslation();
  const {
    medical_referral_status,
    plan_of_care_status,
    medical_referral_id,
    plan_of_care_id,
    plan_of_care_handled_at,
    referral_handled_at,
  } = data || {};

  if (isLoading) {
    return <Spinner small />;
  }

  if (!data && !isLoading) {
    return (
      <Typography textAlign="center" p={2}>
        {t("patients.medical_records.no_signed_medical_records")}
      </Typography>
    );
  }

  return (
    <>
      <PlanOfCareItem
        patientId={patientId}
        planOfCareId={plan_of_care_id}
        date={plan_of_care_handled_at}
        status={plan_of_care_status || "pending"}
      />
      <PhysicianMedicalReferralItem
        patientId={patientId}
        medicalReferralId={medical_referral_id}
        date={referral_handled_at}
        status={medical_referral_status || "pending"}
      />
    </>
  );
};
